import { render, staticRenderFns } from "./incident-message.vue?vue&type=template&id=6d42a578"
import script from "./incident-message.vue?vue&type=script&lang=js"
export * from "./incident-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports